import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const NewsletterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
`;

const NewsletterTitle = styled.h3`
  font-family: "Kinder", sans-serif;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  text-align: center;
`;

const NewsletterForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
`;

const CheckboxContainer = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  cursor: pointer;
  user-select: none;
`;

const CheckboxInput = styled.input`
  margin-top: 0.2rem;
  cursor: pointer;
`;

const PrivacyError = styled.p`
  color: #ff0000;
  font-size: 0.8rem;
  margin-top: 0.5rem;
`;

const Newsletter = ({ title, children }) => {
  const [email, setEmail] = useState("");
  const [checked, setChecked] = useState(false);
  const [showPrivacyError, setShowPrivacyError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);
  const STORAGE_KEY = "newsletter-itsgreener";

  useEffect(() => {
    // Verificar si ya está suscrito al cargar el componente
    const checkSubscription = () => {
      const subscribed = localStorage.getItem(STORAGE_KEY) === "true";
      setIsSubscribed(subscribed);
    };

    checkSubscription();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!checked) {
      setShowPrivacyError(true);
      return;
    }

    setShowPrivacyError(false);
    setError("");
    setIsSubmitting(true);

    try {
      const response = await window.newsletterSubscribeNew(email);
      
      if (response.success) {
        setIsSuccess(true);
        setEmail("");
        setChecked(false);
        // Establecer la suscripción en localStorage
        localStorage.setItem(STORAGE_KEY, "true");
        setIsSubscribed(true);
      } else {
        setError(response.error || "Error al suscribirse");
      }
    } catch (err) {
      setError("Error al suscribirse. Por favor, inténtelo de nuevo.");
      console.error("Error subscribing to newsletter:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Si ya está suscrito, no mostrar el formulario
  if (isSubscribed) {
    return null;
  }

  return (
    <NewsletterContainer>
      {title && <NewsletterTitle>{title}</NewsletterTitle>}
      {children({
        email,
        setEmail,
        checked,
        setChecked,
        showPrivacyError,
        setShowPrivacyError,
        isSubmitting,
        isSuccess,
        error,
        handleSubmit,
      })}
    </NewsletterContainer>
  );
};

Newsletter.propTypes = {
  title: PropTypes.string,
  children: PropTypes.func.isRequired,
};

export default Newsletter; 